import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';
import { LocalstorageService } from 'src/app/global/localstorage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

 // public accessRight = AccessRights;
  data: any;
  public Token: string;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService) {
      // this.data = JSON.parse(localStorage.getItem('currentUser'));
      // this.Token = LocalstorageService.getLocal('Token');

      // if(this.data != null)
      //   this.Token = this.data.token;
  }

  // public InitHeader() {
  //   let headers;
  //   if(this.Token) {
  //     headers = { 'Authorization': 'Bearer ' + this.Token, 
  //     'Content-Type': 'application/json'  };
  //   }
  //   return headers;
  // }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = state.url.substr(1);
   const currentUser = this.authenticationService.currentUserValue;

    if (url.indexOf('?') !== -1) {
      url = url.split('?')[0];
    }
    if (currentUser != null) {
      if (currentUser.userMenu.indexOf(url) !== -1) {
        const userRights = this.authenticationService.currentUserRights(url);

    //    this.accessRight.isAdd = userRights.isadd;
        // this.accessRight.isEdit = userRights.isedit;
        // this.accessRight.isDelete = userRights.isdelete;
        if (currentUser) { 
          return true;
        }
        // logged in so return true
        
      }

      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
    else {
       this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}

